import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sLayout" }
const _hoisted_2 = { class: "sLayout__body" }
const _hoisted_3 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_air-quality" }, null, -1)
const _hoisted_5 = { class: "wrapper" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "numOfBar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InfinityScroll = _resolveComponent("InfinityScroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_InfinityScroll, {
        onLoadNextPage: _ctx.loadAirQualitySensors,
        data: _ctx.sensors,
        loading: _ctx.isLoading
      }, {
        default: _withCtx(() => [
          (_ctx.sensors.data.length === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t("global.no_data")), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sensors.data, (sensor) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: sensor.id,
              to: { name: 'AirQualityById', params: { id: sensor.id } },
              class: "flex customTabLink",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('sidebar-toggled')))
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createElementVNode("span", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(sensor.name), 1),
                  _createElementVNode("span", {
                    class: _normalizeClass(["progressBar", _ctx.getSensorColorClass(parseInt(sensor.measurements?.index))])
                  }, [
                    _createVNode(_component_ProgressBar, {
                      value: sensor.measurements?.index / 2
                    }, null, 8, ["value"]),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(sensor.measurements?.index), 1)
                  ], 2)
                ])
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["onLoadNextPage", "data", "loading"])
    ])
  ]))
}